import { Helmet } from 'react-helmet'
import MainHeader from '../../../components/MainHeader'
import MainFooter from '../../../components/MainFooter'
import CTAButton from '../../../components/CTAButton.js'
import HorizontalScrollSlider from '../../../components/HorizontalScrollSlider.js'
import BackButton from '../../../components/MainComponents.js'

import { motion } from "framer-motion";

import './ServiceAI.css'
import './MServiceAI.css'
import { boxvar1, boxvar2, boxvar2_1, boxvar2_2, boxvar2_3, boxvar2dyndelay, boxvar4, oPU } from '../../../core.js'
import { faArrowRight, faChevronRight, faMagnifyingGlassArrowRight } from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import example_beratung from '../../../assets/pictures/sectionimages/example_beratung.webp'
import example_umsetzung from '../../../assets/pictures/sectionimages/example_umsetzung.webp'
import example_schulung from '../../../assets/pictures/sectionimages/example_schulung.webp'

var slides = [
    { img: example_beratung, caption: "Beratung", description: "Wir beraten dich individuell bei der Auswertung bestehender Daten in deinem Unternehmen.", bg: "var(--ci_color_tilebg)" },
    { img: example_umsetzung, caption: "Umsetzung", description: "Anhand der Datenlage erarbeiten wir die passenden Algorithmen und binden diese in die bestehenden (Entscheidungs-)Prozesse ein.", bg: "var(--ci_color_tilebg)" },
    { img: example_schulung, caption: "Schulung", description: "Wir machen deine Mitarbeiter zu AI-Natives, die keine Angst mehr vor der KI-Zukunft haben, sondern zu wahren Power-Usern werden.", bg: "var(--ci_color_tilebg)" },
];

export default function ServiceAI() {

    return (
        <div className='mainCon' id='mainCon'>

            <MainHeader selectedsite={"services"} disableanimation={false} />

            <Helmet>
                <meta charSet="utf-8" />
                <title>ToN - KI-Beratung</title>
                <meta property="og:title" content="Intelligenz und Datenanalyse" />
                <meta property="og:description" content="Du hast viele Daten und weißt nicht, was du damit machen kannst? Wir helfen dir bei der Auswertung" />
                <meta name="description" content="Du hast viele Daten und weißt nicht, was du damit machen kannst? Wir helfen dir bei der Auswertung" />
            </Helmet>
            <section className='sec_next' id='sec_next--service-ai'>
                <div className='sec_next_cont' id="sec_next--service-ai--cont" style={{ wordBreak: "break-word" }}>
                    <BackButton href='/services' />


                    <motion.div variants={boxvar2_1} className='about_section_cont' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <br />
                        <h2>Viel Daten - Mehr Auswertung.</h2>
                        <h3>Intelligente Entscheidungen nicht nur aus dem Bauch heraus.</h3>
                        <p>
                            Für uns ist KI nicht nur ein trendiges Buzzword - wir beschäftigen uns bereits seit Jahren mit der computerbasierten Datenauswertung.<br />
                            Anhand konkreter Vorhersagen und berechneten Empfehlungen kannst du mit einem ruhigen Gewissen Entscheidungen treffen.<br />
                            <br />
                            <h3>Wir beraten dich bei der Vorbereitung, Auswahl, Umsetzung und Integration der Algorithmen.</h3>
                            Du hast die Daten - wir die Expertise.<br />
                            Wir setzen dabei nicht nur auf die allgemein bekannten LLM (Large-Language-Models) wie ChatGPT, sondern vor allem auch auf eigens entwickelte Prediction Modelle, die speziell für deine Bedürfnisse geeignet sind.
                        </p>

                        <motion.div variants={boxvar4} style={{}} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                            <HorizontalScrollSlider slides={slides} />

                        </motion.div>

                        <p>
                            Du möchtest dein Unternehmen auf ein neues Niveau heben und zukunftssicher machen?
                        </p>
                        <CTAButton className="" showArrow={true} customIcon={null} iconLeft={false} title={"Jetzt beraten lassen"} onclick={() => { oPU('https://calendly.com/tonetworkde-meet/getintouch') }}></CTAButton>



                    </motion.div>


                    <br /><br />

                    <motion.div variants={boxvar2_1} style={{}} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                        <h2>Unsere Leistungen</h2>
                        <p>
                            Wir decken den Bereich Künstliche Intelligenz End-to-End ab, d.h. von der Planung bis hin zur Schulung, aber auch der individuellen Entwicklung eigener Modelle.<br />
                            Bevor es losgeht, beraten wir dich ausführlich und zeigen dir wie deine bisher im Unternehmen anfallenden Daten am besten aufbereitet und genutzt werden könnten.<br />
                            Um deinen Angestellten die Angst zu nehmen, bieten wir auch Schulungen an. Hier erlernen sie neben den Grundlagen auch den konkreten Umgang mit ChatGPT und co, sowie die optimale Interpretation der gesammelten Daten.
                        </p>
                    </motion.div>

                    <br /><br />

                    <motion.div variants={boxvar2_1} style={{}} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                        <h2>Warum wir?</h2>
                        <ul>
                            <li>Wir bieten dir einen Rundum-Service, damit du dich entsptannt auf dein Business konzentrieren kannst. Das reicht von Appdesign, AI-Entwicklung bis hin zu Content-Creation</li>
                            <li>Mehrjährige Erfahrung und Ausbildung im Bereich Data Analytics</li>
                            <li>Wir stehen dir auch nach Abschluss des Projekts als langjähriger Partner zur Seite</li>
                            <li>Langjährige Erfahrung in der Softwareentwicklung mit Spezialisierung auf Webentwicklung und Projektmanagement</li>
                            <li>Best Practices = Our Practices</li>
                            <li>Unsere Leistungen sind unabhängig von der Größe deines Projekts</li>
                        </ul>

                    </motion.div>

                    <br /><br /><br /><br />


                    <motion.div variants={boxvar2_1} style={{}} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <h2>Was kostet das?</h2>
                        <p>
                            Eine transparente Preisübersicht findest du auf unserer Preise-Seite. Alle dort genannten Beträge sind <b>Listenpreise ohne Rabatte</b> und werden individuell auf dein Projekt zugeschnitten.
                        </p>
                        <br />
                        <CTAButton className="" showArrow={true} customIcon={null} iconLeft={false} title={"Zu den Preisen"} href={'/pricing'}></CTAButton>
                    </motion.div>

                    <br /><br /><br /><br />

                    <motion.div variants={boxvar2dyndelay} className='small_services_box small_services_box-bigbottom' initial="hidden" exit="hidden" whileInView="visible" custom={0.3} viewport={{ once: false, margin: "-50px" }}>
                        <div className='small_services_textbox'>
                            <h3>&lt;Individuelle Entwicklung und Beratung/&gt;</h3>
                            <br /><br />
                            <p>
                                Du bist bei unseren Leistungen nicht fündig geworden? Wir sind offen für Herausforderungen 😉<br />
                                Wir stehen dir mit Expertise zur Seite und entwickeln bspw. ein Branding für deine Marke, eine Elektronikkomponente oder eine individuelle Softwarelösung für dich.
                            </p>
                            <CTAButton className="" showArrow={true} customIcon={null} iconLeft={false} title={"Jetzt anfragen"} href={'/support'}></CTAButton>
                        </div>
                    </motion.div>

                    <br /><br /><br /><br />
                </div>
            </section >

            <MainFooter />
        </div >
    )
}
